import { render, staticRenderFns } from "./Attendee.vue?vue&type=template&id=73504cf1&lang=pug"
import script from "./Attendee.vue?vue&type=script&lang=ts"
export * from "./Attendee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports